import { ArrowRight } from "lucide-react";
import { Button } from "../components/ui/button";
import { TextRotate } from "@/components/ui/text-rotate";

const Hero = () => {
  return (
    <section className="">
      <div className="container pt-8 ">
        <div className="mb-2">
          <span className="py-1 px-2 text-sm text-muted-foreground ">
            (Hello, I'm Jakub Wawrysiewicz)
          </span>
        </div>
        <h1 className="font-serif text-5xl md:text-7xl max-w-5xl tracking-tighter font-regular">
          <TextRotate
            texts={["Transforming ideas into stunning web solutions."]}
            staggerFrom="first"
            staggerDuration={0.03}
            splitBy="characters"
          />
        </h1>

        <div className="flex flex-col  justify-between items-start gap-6 mt-4">
          <p className="font-serif text-lg md:text-xl leading-relaxed tracking-tight text-muted-foreground max-w-2xl ">
            Specializing in sleek, user-friendly digital experiences for brands
            that value design, performance, and innovation.
          </p>
          <div className="flex gap-8 items-center">
            <Button asChild size="lg" className="group">
              <a href="#contact" className="inline-flex items-center gap-2">
                Start a project
                <ArrowRight
                  className="-me-2 ms-0 transition-transform group-hover:translate-x-0.5"
                  size={16}
                  strokeWidth={2}
                  aria-hidden="true"
                />
              </a>
            </Button>
            <div className="w-auto">
              <div className="flex items-center justify-start gap-1">
                <span className="relative flex h-3 w-3 items-center justify-center">
                  <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-green-500 opacity-75"></span>
                  <span className="relative inline-flex h-2 w-2 rounded-full bg-green-500"></span>
                </span>
                <p className="text-xs text-green-500">Available Now</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
